/**
 * Header "more info" dropdown and the disclaimer, changelog, and intake-form
 * modals. Extracted verbatim from the globe client monolith (Phase 2, PR-B).
 * Self-contained DOM wiring, typed against the DOM (intake form/inputs).
 */
/* eslint-disable */
export function initModals(): void {
    var infoModalFocusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    function setupInfoModal(openId, overlayId, closeId) {
      var openItem = document.getElementById(openId);
      var overlay = document.getElementById(overlayId);
      var closeBtn = document.getElementById(closeId);
      if (!openItem || !overlay || !closeBtn) return;

      function getFocusable() {
        return Array.prototype.slice.call(overlay.querySelectorAll(infoModalFocusableSelectors));
      }

      function openModal() {
        var infoMenu = document.getElementById('more-info-menu');
        var infoBtn = document.getElementById('more-info-btn');
        if (infoMenu) infoMenu.classList.remove('open');
        if (infoBtn) infoBtn.setAttribute('aria-expanded', 'false');
        overlay.classList.add('open');
        var focusable = getFocusable();
        if (focusable.length) focusable[0].focus();
        else closeBtn.focus();
      }

      function closeModal() {
        overlay.classList.remove('open');
        openItem.focus();
      }

      openItem.addEventListener('click', openModal);

      closeBtn.addEventListener('click', closeModal);

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });

      document.addEventListener('keydown', function(e) {
        if (!overlay.classList.contains('open')) return;
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key !== 'Tab') return;
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    // More info dropdown
    (function() {
      var moreInfoBtn = document.getElementById('more-info-btn');
      var moreInfoMenu = document.getElementById('more-info-menu');
      var dropdown = document.getElementById('more-info-dropdown');

      moreInfoBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = moreInfoMenu.classList.contains('open');
        moreInfoMenu.classList.toggle('open', !isOpen);
        moreInfoBtn.setAttribute('aria-expanded', String(!isOpen));
      });

      function closeMenu(e) {
        if (!dropdown.contains(e.target)) {
          moreInfoMenu.classList.remove('open');
          moreInfoBtn.setAttribute('aria-expanded', 'false');
        }
      }

      document.addEventListener('click', closeMenu);
      document.addEventListener('touchstart', closeMenu, { passive: true });
    })();

    setupInfoModal('about-atlas-btn', 'about-atlas-overlay', 'about-atlas-close');
    setupInfoModal('disclaimer-btn', 'disclaimer-overlay', 'disclaimer-close');

    // Changelog modal
    (function() {
      var openBtn = document.getElementById('changelog-open-btn');
      var overlay = document.getElementById('changelog-overlay');
      var closeBtn = document.getElementById('changelog-modal-close');
      var moreInfoMenu = document.getElementById('more-info-menu');
      var moreInfoBtn = document.getElementById('more-info-btn');

      function openModal() {
        moreInfoMenu.classList.remove('open');
        moreInfoBtn.setAttribute('aria-expanded', 'false');
        overlay.classList.add('open');
        history.replaceState(null, '', '#changelog');
      }

      function closeModal() {
        overlay.classList.remove('open');
        history.replaceState(null, '', location.pathname + location.search);
        openBtn.focus();
      }

      openBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        openModal();
      });

      closeBtn.addEventListener('click', closeModal);

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('open')) closeModal();
      });

      window.addEventListener('popstate', function() {
        if (location.hash !== '#changelog' && overlay.classList.contains('open')) {
          overlay.classList.remove('open');
        }
      });

      if (location.hash === '#changelog') openModal();
    })();

    // Intake form modal
    (function() {
      var openBtn = document.getElementById('intake-open-btn');
      var overlay = document.getElementById('intake-overlay');
      var modal = document.getElementById('intake-modal');
      var closeBtn = document.getElementById('intake-modal-close');
      var cancelBtn = document.getElementById('intake-cancel-btn');
      var submitBtn = document.getElementById('intake-submit-btn') as HTMLButtonElement;
      var form = document.getElementById('intake-form') as HTMLFormElement;
      var successState = document.getElementById('intake-success');
      var modalBody = document.getElementById('intake-modal-body');
      var modalFooter = document.getElementById('intake-modal-footer');
      var moreInfoMenu = document.getElementById('more-info-menu');
      var moreInfoBtn = document.getElementById('more-info-btn');
      var countryInput = document.getElementById('intake-country') as HTMLInputElement;
      var detailInput = document.getElementById('intake-detail') as HTMLTextAreaElement;

      var focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(',');

      function getFocusable() {
        return Array.prototype.slice.call(modal.querySelectorAll(focusableSelectors));
      }

      function openModal() {
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
        history.replaceState(null, '', '#propose');
        var focusable = getFocusable();
        if (focusable.length) focusable[0].focus();
      }

      function closeModal() {
        overlay.classList.remove('open');
        document.body.style.overflow = '';
        history.replaceState(null, '', location.pathname + location.search);
        if (openBtn) openBtn.focus();
      }

      function setFieldError(input: HTMLInputElement | HTMLTextAreaElement, message: string) {
        var field = input.closest('.intake-field');
        var error = document.getElementById(input.id + '-error');
        if (message) {
          field?.classList.add('invalid');
          input.setAttribute('aria-invalid', 'true');
          if (error) error.textContent = message;
        } else {
          field?.classList.remove('invalid');
          input.removeAttribute('aria-invalid');
        }
      }

      function clearRequiredErrors() {
        setFieldError(countryInput, '');
        setFieldError(detailInput, '');
      }

      function resetModal() {
        form.reset();
        form.style.display = '';
        successState.classList.remove('visible');
        modalFooter.style.display = '';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
        clearRequiredErrors();
      }

      openBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        moreInfoMenu.classList.remove('open');
        moreInfoBtn.setAttribute('aria-expanded', 'false');
        resetModal();
        openModal();
      });

      closeBtn.addEventListener('click', closeModal);
      cancelBtn.addEventListener('click', closeModal);

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
      });

      document.addEventListener('keydown', function(e) {
        if (!overlay.classList.contains('open')) return;
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key !== 'Tab') return;
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      window.addEventListener('popstate', function() {
        if (location.hash !== '#propose' && overlay.classList.contains('open')) {
          overlay.classList.remove('open');
          document.body.style.overflow = '';
        }
      });

      if (location.hash === '#propose') { resetModal(); openModal(); }

      countryInput.addEventListener('input', function() {
        if (countryInput.value.trim()) setFieldError(countryInput, '');
      });

      detailInput.addEventListener('input', function() {
        if (detailInput.value.trim()) setFieldError(detailInput, '');
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        clearRequiredErrors();
        var firstInvalidField: HTMLInputElement | HTMLTextAreaElement | null = null;
        if (!countryInput.value.trim()) {
          setFieldError(countryInput, 'Country is required.');
          firstInvalidField = countryInput;
        }
        if (!detailInput.value.trim()) {
          setFieldError(detailInput, 'Detail is required.');
          if (!firstInvalidField) firstInvalidField = detailInput;
        }
        if (firstInvalidField) {
          firstInvalidField.focus();
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting\u2026';

        var data = {
          name: (document.getElementById('intake-name') as HTMLInputElement).value.trim(),
          organization: (document.getElementById('intake-org') as HTMLInputElement).value.trim(),
          email: (document.getElementById('intake-email') as HTMLInputElement).value.trim(),
          country: countryInput.value.trim(),
          subgeography: (document.getElementById('intake-subgeo') as HTMLInputElement).value.trim(),
          changeType: (document.getElementById('intake-type') as HTMLSelectElement).value,
          detail: detailInput.value.trim(),
          source: (document.getElementById('intake-source') as HTMLInputElement).value.trim(),
          subscribe: (document.getElementById('intake-subscribe') as HTMLInputElement).checked,
        };

        fetch('/api/intake', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Request failed');
            form.style.display = 'none';
            modalFooter.style.display = 'none';
            successState.classList.add('visible');
          })
          .catch(function() {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit';
            alert('Something went wrong. Please try again.');
          });
      });
    })();

}
